import { createSlice } from '@reduxjs/toolkit'

export const raceOddsSlice = createSlice({
  name: 'raceOdds',
  initialState: null,
  reducers: {
    getOddsSuccess: (state, action) => {
      return {
        ...state,
        [`${action.payload.match_id} ${action.payload.marketId}`]: action.payload.data
      }
    },
    getOddsError: (state) => state,
  },
})

export const { getOddsSuccess, getOddsError } = raceOddsSlice.actions

export default raceOddsSlice.reducer